import React from 'react';
import { Stack } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import { FireIcon } from '@cp/ds/src/icons';
import { styled } from '@cp/ds/src/theme';
import { SxProps } from '@cp/ds';

const ICON_SIZE = 16;

const Root = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  flexShrink: 0,
  gap: theme.spacing(0.25),
  padding: theme.spacing(0.5, 1, 0.5, 0.75),
  minHeight: 26,
  backgroundColor: theme.palette['brand pink'],
  borderRadius: '20px',
}));

export const HotBadge: React.FC<{ sx?: SxProps }> = ({ sx }) => {
  return (
    <Root sx={sx}>
      <FireIcon sx={{ fontSize: ICON_SIZE, color: 'white', flexShrink: 0 }} />
      <Typography sx={{ color: 'white', whiteSpace: 'nowrap' }} variant="small text bold">
        Горящая
      </Typography>
    </Root>
  );
};
